import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const TournamentInfoComponent = React.lazy(() => import("../Components/RootComponents/TournamentInfoComponent"));
const TournamentInfoPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <TournamentInfoComponent />
      </Suspense>
    </Fragment>
  );
};

export default TournamentInfoPage;
